import { Link } from 'react-router-dom';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { ChevronRightIcon, Join, Paragraph, Skeleton, tokens } from '@treams/treams-ui';

const Chevron = styled(Box)`
	svg {
		display: block;
		width: 16px;
		height: 16px;

		path {
			fill: ${tokens.icon.secondary};
		}
	}
`;

const Crumb = styled(Paragraph)`
	cursor: pointer;
	color: ${tokens.text.secondary};
	white-space: pre;
	overflow: hidden;
	text-overflow: ellipsis;
	border-radius: ${tokens.radius.sm}px;

	&:hover {
		background: ${tokens.surface.hover};
		color: ${tokens.text.primary};
		padding: 2px 6px;
		margin: -2px -6px;
	}
`;

const Last = styled(Paragraph)`
	color: ${tokens.text.primary};
	white-space: pre;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export default function Breadcrumbs(props: {
	components: { id: string; to?: string; name: string; readOnly?: boolean }[];
	onChange?: (id: string) => void;
}) {
	return (
		<Join
			alignItems="center"
			separator={
				<Chevron flexGrow={0} flexShrink={0}>
					<ChevronRightIcon />
				</Chevron>
			}
		>
			{props.components.map(({ id, to, name, readOnly }, index) =>
				index === props.components.length - 1 || readOnly === true ? (
					<Last key={id} mb={0} fontWeight="medium" flexShrink={0} flexGrow={0}>
						{name}
					</Last>
				) : to ? (
					<Link to={to} key={id}>
						<Crumb mb={0} flexGrow={0} flexShrink={1}>
							{name}
						</Crumb>
					</Link>
				) : (
					<Crumb
						key={id}
						mb={0}
						onClick={() => id && props.onChange && props.onChange(id)}
						flexGrow={0}
						flexShrink={1}
					>
						{name}
					</Crumb>
				),
			)}
		</Join>
	);
}

Breadcrumbs.Skeleton = styled(Skeleton.Box)`
	width: 200px;
	height: 20px;
`;
